import {
  AiChatActionType,
  ChatSession,
  MessageActor,
  MessageType,
  ShipmentStatus
} from './api/chat/types';

export const isRemainingItemsReviewMessage = (session: ChatSession | null, messageId: number | undefined): boolean => {
  if (!session?.remaining_composition_review || session.shipment_status !== ShipmentStatus.CONFIRMED_ITEMS) {
    return false;
  }

  const lastMessage = session.message_history[session.message_history.length - 1];

  return lastMessage?.actor === MessageActor.AGENT
    && lastMessage.message_id === messageId
    && lastMessage.response_type === MessageType.WIDGET_ITEMS
    && lastMessage.actions?.includes(AiChatActionType.CONFIRM_REMAINING_ITEMS) === true;
};